import Events from "events";

class EventEmitter extends Events {
	constructor() {
		super();
		this.setMaxListeners(0);
	}
}

// Export named only - no default export to avoid Webpack initialization order issues
// This prevents "Cannot access 'o' before initialization" errors during Next.js build
// All imports must use named import: import { EventEmitter } from "@Front/Services/EventEmitter";
export { EventEmitter };
